import { api } from "@/lib/axios";

export interface Message {
  _id: string;
  senderId: {
    _id: string;
    name: string;
    email: string;
    avatar?: string;
  };
  receiverId: {
    _id: string;
    name: string;
    email: string;
    avatar?: string;
  };
  propertyId: {
    _id: string;
    title: string;
    images: string[];
  };
  content: string;
  read: boolean;
  readAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SendMessageData {
  receiverId: string;
  propertyId: string;
  content: string;
}

export const getMessages = async (): Promise<Message[]> => {
  try {
    const response = await api.get("/api/messages");
    return response.data;
  } catch (error) {
    console.error("Error fetching messages:", error);
    throw error;
  }
};

export const getPropertyMessages = async (propertyId: string): Promise<Message[]> => {
  try {
    const response = await api.get(`/api/messages/property/${propertyId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching property messages:", error);
    throw error;
  }
};

export const sendMessage = async (data: SendMessageData): Promise<Message> => {
  try {
    const response = await api.post("/api/messages", data);
    return response.data;
  } catch (error) {
    console.error("Error sending message:", error);
    throw error;
  }
};

export const markAsRead = async (messageId: string): Promise<Message> => {
  try {
    const response = await api.patch(`/api/messages/${messageId}/read`);
    return response.data;
  } catch (error) {
    console.error("Error marking message as read:", error);
    throw error;
  }
};

export const deleteMessage = async (messageId: string): Promise<void> => {
  try {
    await api.delete(`/api/messages/${messageId}`);
  } catch (error) {
    console.error("Error deleting message:", error);
    throw error;
  }
};

export const getUnreadCount = async (): Promise<number> => {
  try {
    const response = await api.get("/api/messages/unread/count");
    return response.data.count;
  } catch (error) {
    console.error("Error getting unread count:", error);
    throw error;
  }
}; 